<template>
	<div class="task-search pa-4">
		<div class="search-title">
			<div>{{ title }}</div>
			<v-icon small @click="onClose()">mdi-close</v-icon>
		</div>
		<v-btn 
			class="white--text text-capitalize my-4"
			block
			rounded
			color="#00AAFD"
			:disabled="!isActive"
			@click="onSearch()"
		>
			{{ id === 0 ? 'Search Tasks' : 'Update Worklist' }}
		</v-btn>
		<v-expansion-panels
			v-model="panel"
			multiple
			accordion
			flat
		>
			<v-expansion-panel
				v-for="item in panel_items"
				:key="item.value"
			>
				<v-divider class="mx-0"></v-divider>
				<v-expansion-panel-header color="#FAFAFA">
					{{ item.title }}
				</v-expansion-panel-header>
				<v-expansion-panel-content color="#FAFAFA" class="panel-header-item">
					<div>
						<template v-if="item.value === 'assigned'">
							<v-radio-group
								class="my-0 py-0"
								v-model="assigned_select" 
								dense
								@change="onAssignedChange($event)">
								<v-radio
									v-for="assigned_item in assigned_items"
									:key="assigned_item.value"
									:label="assigned_item.text"
									:value="assigned_item.value"
									:color="color"
								>
								</v-radio>
							</v-radio-group>
							<v-divider v-if="append_item.length !== 0" class="mx-0"></v-divider>
							<div v-if="append_item.length !== 0" class="overflow-auto" :style="append_item.length > 6 ? 'height: 180px': ''">
								<v-checkbox
									class="mx-0 mt-0"
									v-model="append_select"
									v-for="item in append_item"
									:key="`${item.id}_${item.type}`"
									:label="item.desc"
									:value="item"
									:color="color"
									hide-details
									dense
									:disabled="item.id === current_user_id && assigned_select === 0"
								></v-checkbox> 
							</div>
						</template>
						<template v-if="item.value === 'date'">
							<div class="panel-header-item">
								<div>Date type</div>
								<v-checkbox
									v-for="item of date_option_items"
									:key="item.value"
									v-model="date_options"
									:label="item.lable"
									:value="item.value"
									:color="color"
									dense
									hide-details
									@change="onDateTypeChange()"
								></v-checkbox>
								<div class="mt-3 mb-1" :class="date_options.length === 1 && date_options[0] === date_options_no ? 'search-text-disable':''">Date range</div>
								<v-select
									v-model="date_select"
									:items="date_items"
									item-color="sucess"
									:color="color"
									:menu-props="{ bottom: true, offsetY: true}"
									:disabled="date_options.length === 1 && date_options[0] === date_options_no"
									:error="(date_options.includes(date_options_suggested) || date_options.includes(date_options_actual)) && date_select.length === 0"
									placeholder="Select..."
									outlined
									dense
									hide-details
								></v-select>
								<v-row v-if="date_select === 'range'">
									<v-col :cols="12" class="mt-2">
										<DateMulti
											:lableText="'Start date to End date'"
											:suggestionText="`eg, 120322-130322 or 12/3/2022-13/3/2022`"
											:color="color"
											:dateStartInit="date_start_origin ? date_start_origin :''"
											:dateEndInit="date_end_origin ? date_end_origin : ''"
											@dateRange="onDateChange($event)"
										/>
									</v-col>
								</v-row>
							</div>
						</template>
						<template v-if="item.value === 'status'">
							<div v-if="statuses.length > list_limit">
								<v-autocomplete
									class="mb-2"
									v-model="status_select"
									:items="statuses"
									:color="color"
									append-icon=""
									prepend-inner-icon="search"
									background-color="#FAFAFA"
									item-text="desc"
									item-color="success"
									outlined
									dense
									multiple
									return-object
									hide-no-data
									hide-details
								>
									<template v-slot:selection="data">
										<div></div>
									</template>	
								</v-autocomplete>
								<v-virtual-scroll
									:items="statuses"
									:item-height="32"
									height="168"
								>
									<template v-slot:default="{ item }">
										<v-checkbox
											class="mt-0"
											v-model="status_select"
											:label="item.desc"
											:value="item"
											:color="color"
											dense
											hide-details
										>
											<template v-slot:label>
												<v-badge
													:color="item.color"
													left
													inline
												>
													<span class="ml-1">{{ item.desc }}</span>
												</v-badge>
											</template>
										</v-checkbox>
									</template>
								</v-virtual-scroll>
							</div>
							<div v-if="statuses.length <= list_limit">
								<v-checkbox
									class="mt-0 pt-0 mb-4"
									v-for="item in statuses"
									:key="item.id"
									v-model="status_select"
									:label="item.desc"
									:value="item"
									:color="color"
									dense
									hide-details
								>
									<template v-slot:label>
										<v-badge
											:color="item.color"
											left
											inline
										>
											<span class="ml-1">{{ item.desc }}</span>
										</v-badge>
									</template>
								</v-checkbox>
							</div>
						</template>
						<template v-if="item.value === 'type'">
							<div v-if="job_types.length > list_limit">
								<v-autocomplete
									class="mb-2"
									v-model="job_type_selected"
									:items="job_types"
									:color="color"
									append-icon=""
									prepend-inner-icon="search"
									background-color="#FAFAFA"
									item-text="desc"
									item-color="success"
									outlined
									dense
									multiple
									return-object
									hide-no-data
									hide-details
								>
									<template v-slot:selection="data">
										<div></div>
									</template>	
								</v-autocomplete>
								<v-virtual-scroll
									:items="job_types"
									:item-height="32"
									height="168"
								>
									<template v-slot:default="{ item }">
										<v-checkbox
											class="mt-0"
											v-model="job_type_selected"
											:label="item.desc"
											:value="item"
											:color="color"
											dense
											hide-details
										></v-checkbox>
									</template>
								</v-virtual-scroll>
							</div>
							<div v-if="job_types.length <= list_limit">
								<v-checkbox
									class="mt-0 pt-0 mb-4"
									v-for="item in job_types"
									:key="item.id"
									v-model="job_type_selected"
									:label="item.desc"
									:value="item"
									:color="color"
									dense
									hide-details
								></v-checkbox>
							</div>
						</template>
						<template v-if="item.value === 'budget'">
							<v-checkbox
								class="mt-0 pt-0 mb-4"
								v-for="item in budget_items"
								:key="`budget_${item.value}`"
								v-model="budget_select"
								:label="item.text"
								:value="item"
								:color="color"
								dense
								hide-details
							></v-checkbox>
						</template>
						<template v-if="item.value === 'priority'">
							<v-checkbox
								class="mt-0 pt-0 mb-4"
								v-model="isPriority"
								label="search with priorities"
								:color="color"
							></v-checkbox>
							<v-range-slider
								v-model="priority_range"
								step="1"
								max="5"
								min="1"
								dense
								hide-details
								thumb-label="always"
								:thumb-size="20"
								:color="color"
								:thumb-color="color"
								:disabled="!isPriority"
								track-color="#C4C4C4"
							>
								<template v-slot:thumb-label="props">
									<div>
										{{ props.value }}
									</div>
								</template>
							</v-range-slider>
						</template>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</div>
</template>
<script>
import DateMulti from "@/components/date/date_multi.vue";
import moment from 'moment';

const Panel_Items = [
	{
		title: 'Assigned to',
		value: 'assigned'
	},
	{
		title: 'Dates',
		value: 'date'
	},
	{
		title: 'Task status',
		value: 'status'
	},
	{
		title: 'Job types',
		value: 'type'
	},
	{
		title: 'Budget Types',
		value: 'budget'
	},
	{
		title: 'Priority',
		value: 'priority'
	},
];

const Assigned_Items = [
	{
		text: 'Employees',
		value: 1,
	},
	{
		text: 'Roles',
		value: 3,
	},
	{
		text: 'Departments',
		value: 4,
	},
	{
		text: 'You',
		value: 0,
	},
	{
		text: 'Not assigned',
		value: 5,
	},
];

const Budget_Types = [
	{
		text: 'No budget',
		value: 0,
	},
	{
		text: 'Value only',
		value: 1,
	},
	{
		text: 'Minutes and value',
		value: 2,
	},
	{
		text: 'Units and value',
		value: 3,
	},
];

const Date_Items = [
	{
		text: 'Today',
		value: 'today',
		mode: 0
	},
	{
		text: 'Next 7 days',
		value: 'week',
		mode: 1,
	},
	{
		text: 'This month',
		value: 'month',
		mode: 4,
	},
	{
		text: 'Date range',
		value: 'range',
		mode: 2,
	},
	{
		text: 'Prior to Today',
		value: 'past',
		mode: 3,
	},
];

const Date_Options = [
	{
		value: 'nodates',
		lable: "No dates",
	},
	{
		value: 'suggested',
		lable: "Suggested dates"
	},
	{
		value: 'actual',
		lable: "Actual dates"
	}
];
const Date_Options_Suggested = 'suggested';
const Date_Options_Actual = 'actual';
const Date_Options_No = 'nodates';

const ALLEMPLOYEES = 1;
const YOU = 0;
const ROLES = 3;
const DEPARTMENTS = 4;
const ANYONE = 2;
const UNASSIGNED = 5;

const ACTIVE_STATUS = 2; // according to meta, status=2 => 'Active'

export default {
	name: 'TaskSearch',
	props: {
		id: {
			type: Number,
			default: 0
		},
		title: {
			type: String,
			default: ''
		},
		settings: {
			type: Object,
			default: () => {}
		},
		color: {
			type: String,
			default: ''
		},
		statuses: {
			type: Array,
			default: () => []
		},
	},
	components: {
		DateMulti
	},
	data() {
		this.date_options_suggested = Date_Options_Suggested;
		this.date_options_actual = Date_Options_Actual;
		this.date_options_no = Date_Options_No;
		this.list_limit = 6;

		return {
			error_msg: '',
			departments: [],
			roles: [],
			employees_local: [],
			you: null,
			isActive: false,
      
			panel_items: Panel_Items,
			panel: this.id === 0 ? [0, 1] :Panel_Items.map((k, i) => { return i}),

			assigned_items: Assigned_Items,
			assigned_select: null,
			assigned_select_origin: null,
			
			append_item: [],
			append_select: [],
			append_select_origin: [],

			status_select: this.statuses.filter(s => { return s.type === ACTIVE_STATUS }),
			status_select_origin: this.statuses.filter(s => { return s.type === ACTIVE_STATUS }),

			job_types: [],
			job_type_selected: [],
			job_type_selected_origin: [],

			budget_items: Budget_Types,
			budget_select: Budget_Types,
			budget_select_origin: Budget_Types,

			isPriority: true,
			isPriority_origine: true,
			priority_range: [1, 5],
			priority_rang_origine: [1, 5],

			date_option_items: Date_Options,
			date_options: [Date_Options_Actual, Date_Options_Suggested],
			date_options_origin: [Date_Options_Actual, Date_Options_Suggested],

			date_items: Date_Items,
			date_select: '',
			date_select_origin: '',

			date_start: null,
			date_start_origin: null,

			date_end: null,
			date_end_origin: null,
		}
	},
	async created() {
		await this.getJobType();
		this.getDepartments();
		this.getRoles();
		this.getAllEmployees();
		this.getYou();
		this.initDefaultValue();
	},
	watch: {
		error_msg() {
			if (this.error_msg.length !== 0) {
				this.$emit('error-msg', this.error_msg);
			}
		},
		employees_local() {
			if (this.employees_local.length !== 0) {
				if (this.assigned_select === ALLEMPLOYEES) {
					this.append_item =[...this.employees_local];
					this.append_select = this.employees_local.filter(e => { return this.settings.employees.includes(e.id)});
					this.append_select_origin = this.append_select;
				}
			}
		},
		roles() {
			if (this.roles.length !== 0) {
				if (this.assigned_select === ROLES) {
					this.append_item =[...this.roles];
					this.append_select = this.roles.filter(r => { return this.settings.roles.includes(r.id)});
					this.append_select_origin = this.append_select;
				}
			}
		},
		departments() {
			if (this.departments.length !== 0) {
				if (this.assigned_select === DEPARTMENTS) {
					this.append_item =[...this.departments];
					this.append_select = this.departments.filter(d => { return this.settings.departments.includes(d.id)});
					this.append_select_origin = this.append_select;
				}
			}
		},
		assigned_select() {
			this.isActive = this._isActive();
		},
		append_select() {
			this.isActive = this._isActive();
		},
		status_select() {
			this.isActive = this._isActive();
		},
		job_type_selected() {
			this.isActive = this._isActive();
		},
		budget_select() {
			this.isActive = this._isActive();
		},
		isPriority() {
			this.isActive = this._isActive();
		},
		priority_range() {
			this.isActive = this._isActive();
		},
		date_select() {
			if (this.date_select === 'range' && !this.settings) {
				this.date_start = null;
				this.date_end = null;
			}
			this.isActive = this._isActive();  
		},
		date_start() {
			this.isActive = this._isActive();
		},
		date_end() {
			this.isActive = this._isActive();
		},
		settings() {
			this.initDefaultValue();
		},
	},
	computed: {
		current_user_id() {
			let id = null;
			if (this.$store.state.user) {
				id = this.$store.state.user.id;
			}

			return id;
		},
	},
	methods: {
		async getJobType() {
			const url = '/api/jobs/meta';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.job_types = data.jobtypes;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		getRoles() {
			const url = '/api/config/orgchart/roles';
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.roles = data.map(d => { return { id: d.id, desc: d.desc, type: ROLES } });
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		getDepartments() {
			const url = '/api/config/orgchart/departments';
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.departments = data.map(d => { return { id: d.id, desc: d.desc, type: DEPARTMENTS } });
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		getAllEmployees() {
			let url = '/api/addressbook';
			const params = [];

			// 3 = "Employees", 12 = 'Freelancers', from 'api/addressbook/meta'
			params.push("abook_types=" + encodeURIComponent("3, 12")); 
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const unique = [];
						const obj_tmp = {};
						data.forEach(d => {
							if (!obj_tmp[d.id]) {
								unique.push(d);
								obj_tmp[d.id] = true;
							}
						});

						unique.forEach(e => {
							let display_name = this.formatName(e.display_name);
							const obj = {
								id: e.id,
								desc: display_name,
								type: ALLEMPLOYEES
							};
							this.employees_local.push(obj);
						});
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		getYou() {
			const you_tmp = this.$store.state.user;
			this.you = [{ id: you_tmp.id, desc: you_tmp.name, type: YOU }];
		},
		initDefaultValue() {
			if (this.settings) {
				/* init assigned_select */
				let assigned_select = this.settings.assign_mode;
				if (assigned_select === 2) {
					if (this.settings.roles && this.settings.roles.length !== 0) {
						assigned_select = ROLES;
					} else if (this.settings.departments && this.settings.departments.length !== 0) {
						assigned_select = DEPARTMENTS;
					} else if (this.settings.employees && this.settings.employees.length !== 0) {
						assigned_select = ALLEMPLOYEES;
					} else {
						assigned_select = ANYONE;
					}
				}

				this.assigned_select = assigned_select;
				this.assigned_select_origin = assigned_select;

				/* init append_item and append_select */
				if (assigned_select === YOU) {					
					this.append_item =[...this.you];
					this.append_select = [...this.you];
				}
				if (assigned_select === ALLEMPLOYEES) {
					this.append_item =[...this.employees_local];
					this.append_select = this.settings.employees ? this.employees_local.filter(e => { return this.settings.employees.includes(e.id)}) : this.employees_local;
				}
				if (assigned_select === ROLES) {
					this.append_item =[...this.roles];
					this.append_select = this.settings.roles ? this.roles.filter(r => { return this.settings.roles.includes(r.id)}) : [];
				}
				if (assigned_select === DEPARTMENTS) {
					this.append_item =[...this.departments];
					this.append_select = this.settings.departments ? this.departments.filter(d => { return this.settings.departments.includes(d.id)}) : [];
				}
				if (assigned_select === ANYONE) {
					this.append_item =[];
					this.append_select = [];
				}
				this.append_select_origin = this.append_select;

				/* init status_select */
				this.status_select = this.settings.statusses ? this.statuses.filter(s => { return this.settings.statusses.includes(s.id) }) : this.statuses.filter(s => { return s.type === ACTIVE_STATUS });
				this.status_select_origin = this.settings.statusses ? this.statuses.filter(s => { return this.settings.statusses.includes(s.id) }) : this.statuses.filter(s => { return s.type === ACTIVE_STATUS });

				/* init job_type_select */
				this.job_type_selected = this.settings.job_types ? this.job_types.filter(j => { return this.settings.job_types.includes(j.id)}) : this.job_types;
				this.job_type_selected_origin = this.settings.job_types ? this.job_types.filter(j => { return this.settings.job_types.includes(j.id)}) : this.job_types;

				/* init budget_types */
				this.budget_select = this.settings.budget_types ? this.budget_items.filter(b => { return this.settings.budget_types.includes(b.value) }) : this.budget_items;
				this.budget_select_origin = this.settings.budget_types ? this.budget_items.filter(b => { return this.settings.budget_types.includes(b.value) }) : this.budget_items;

				/* init date options */
				if (this.settings.date_type) {
					this.date_options = this.settings.date_type;
					this.date_options_origin = this.settings.date_type;
				} else {
					this.date_options = [Date_Options_Actual, Date_Options_Suggested, Date_Options_No];
					this.date_options_origin = [Date_Options_Actual, Date_Options_Suggested, Date_Options_No];
				}
				
				/* init date_select */
				let date_select_tmp = '';
				if (this.settings.date_mode === 0) {
					date_select_tmp = 'today';
				} else if (this.settings.date_mode === 1) {
					date_select_tmp = 'week';
				} else if (this.settings.date_mode === 3) {
					date_select_tmp = 'past';
				} else if (this.settings.date_mode === 4) {
					date_select_tmp = 'month';
				} else if (this.settings.date_mode === 2 && this.settings.date_type && this.settings.date_type.length === 1 && this.settings.date_type[0] === Date_Options_No) {
					date_select_tmp = '';
				} else {
					date_select_tmp = 'range';
				}
				this.date_select = date_select_tmp;
				this.date_select_origin = date_select_tmp;

				/* init date_start */
				this.date_start = this.settings.date_mode === 2 ? this.settings.start_date: null;
				this.date_start_origin = this.settings.date_mode === 2 ? this.settings.start_date: null;

				/* init date_end */
				this.date_end = this.settings.date_mode === 2 ? this.settings.end_date : null;
				this.date_end_origin = this.settings.date_mode === 2 ? this.settings.end_date : null;

				/* init priority */
				this.isPriority = this.settings.priorities && this.settings.priorities.length !== 0 ? true: false;
				this.isPriority_origine = this.settings.priorities && this.settings.priorities.length !== 0 ? true: false;

				if (this.isPriority) {
					const priority_tmp = this.settings.priorities;
					this.priority_range = [ priority_tmp[0] + 1, priority_tmp[priority_tmp.length -1] + 1 ];
					this.priority_rang_origine = [ priority_tmp[0] + 1, priority_tmp[priority_tmp.length -1] + 1 ];
				}

			} else {
				this.assigned_select = YOU;
				this.assigned_select_origin = YOU;
				this.onAssignedChange(YOU);

				this.status_select = this.statuses.filter(s => { return s.type === ACTIVE_STATUS });
				this.status_select_origin = this.statuses.filter(s => { return s.type === ACTIVE_STATUS });
			
				this.job_type_selected = this.job_types;
				this.job_type_selected_origin = this.job_types;

				this.budget_select = Budget_Types;
				this.budget_select_origin = Budget_Types;

				this.isPriority = true;
				this.isPriority_origine = true;
				this.priority_range = [1, 5],
				this.priority_rang_origine = [1, 5];

				this.date_select = '';
				this.date_select_origin = '';

				this.date_start = null;
				this.date_start_origin = null;

				this.date_end = null;
				this.date_end_origin = null;
			}
		},
		formatDate(value) {
			if(!value) return null;
			return moment(value).format('DD MMM YYYY');
		},
		formatName(name) {
			let display_name = '';
			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		onClose() {
			this.$emit('close');
		},
		onSearch() {
			let assign_mode = 0;			
			if (this.assigned_select === ROLES || this.assigned_select === DEPARTMENTS ||  this.assigned_select === ALLEMPLOYEES) {
				assign_mode = ANYONE;
			} 
			if (this.assigned_select === YOU) {
				assign_mode = YOU;
			}
			if (this.assigned_select === UNASSIGNED) {
				assign_mode = 3;
			}

			const employees_tmp = this.append_select.filter(a => { return a.type === ALLEMPLOYEES });
			const employees = employees_tmp.map(r => { return r.id });

			const roles_tmp = this.append_select.filter(a => { return a.type === ROLES });
			const roles = roles_tmp.map(r => { return r.id });

			const departments_tmp = this.append_select.filter(a => { return a.type === DEPARTMENTS });
			const departments = departments_tmp.map(r => { return r.id });

			const status = this.status_select.map(s => { return s.id });
			const job_types = this.job_type_selected.map(j => { return j.id });
			const budget_types = this.budget_select.map(b => { return b.value });

			const priorities = [];
			for (let index = this.priority_range[0]; index <= this.priority_range[1]; index++) {
				priorities.push(index - 1);				
			}

			const date_mode = this.date_select.length === 0 ? Date_Items.filter(d => { return d.value === 'range' }) : Date_Items.filter(d => { return d.value === this.date_select });
			const suggested_mode = this._getSuggestedMode(this.date_options);

			const settings_obj = {
				assign_mode: assign_mode,
				roles: roles.length !== 0 ? roles : null,
				departments: departments.length !== 0 ? departments : null,
				employees: employees.length !== 0 ? employees : null,
				statusses: status,
				budget_types: budget_types,
				priorities: this.isPriority ? priorities : null,
				suggested_mode: suggested_mode,
				date_mode: date_mode[0].mode,
				start_date: this.date_start,
				end_date: this.date_end,
				date_type: this.date_options,
				job_types: job_types
			};

			const param = {
				id: this.id,
				settings: settings_obj
			};

			this.$emit('search', param);
		},
		onAssignedChange(assigned_type) {
			this.append_item = [];
			this.append_select = [];

			/* You */
			if (assigned_type === YOU) {
				this.append_item =[...this.you];
				this.append_select = [...this.you];
			}

			/* Employees */
			if (assigned_type === ALLEMPLOYEES) {
				this.append_item =[...this.employees_local];
			}

			/* Roles */
			if (assigned_type === ROLES) {
				this.append_item =[...this.roles];
			}

			/* Departments */
			if (assigned_type === DEPARTMENTS) {
				this.append_item =[...this.departments];
			}    
		},
		onDateTypeChange() {
			if (this.date_options.length === 1 && this.date_options[0] === Date_Options_No) {
				this.date_select = '';
			}
			this.isActive = this._isActive();
		},
		onDateChange(date_arr) {
			this.error_msg = '';

			if (date_arr.length === 0) {
				this.date_start = '';
				this.date_end = '';
			}

			if (date_arr.length === 2) {
				this.date_start = date_arr[0];
				this.date_end = date_arr[1];
			}

			this.isActive = this._isActive();
		},
		_getSuggestedMode(date_type) {
			/** 0 - any, 1 = suggested, 2 = not suggested  */
			let suggested_mode = 0;
			if (date_type.length === 1 && date_type[0] === Date_Options_Suggested) {
				suggested_mode = 1;
			}

			if (date_type.length === 1 && date_type[0] === Date_Options_Actual) {
				suggested_mode = 2;
			}
			return suggested_mode;
		},
		_isEqual(array1, array2) {
			if (array1.length !== array2.length) {
				return false;
			} else {
				array1.sort((a, b) => { return a - b});
				array2.sort((a, b) => { return a - b});

				for (let i = 0; i < array1.length; i++) {
					if (array1[i] !== array2[i]) {
						return false;
					}
				}
				return true;

			}
		},
		_isActive() {
			let isActive = false;

			if (this.settings) {
				if ((this.assigned_select === UNASSIGNED ? true : this.append_select.length !== 0) && this.status_select.length !== 0 && this.job_type_selected.length !== 0 && this.budget_select.length !== 0 && this.date_options.length !== 0) {
					const date_options_sort = this.date_options.sort();
					const date_options_origin_sort = this.date_options_origin.sort();

					if (this.date_options.length === 1 && this.date_options[0] === Date_Options_No) {
						isActive = this._isSettingActive();

						if (date_options_sort.join() !== date_options_origin_sort.join()) {
							isActive = true;
						}
						
					} else {
						if (this.date_select === 'range') {
							if (this.date_start || this.date_end) {
								isActive = this._isSettingActive();

								if (date_options_sort.join() !== date_options_origin_sort.join() || this.date_select !== this.date_select_origin || this.date_start !== this.date_start_origin || this.date_end !== this.date_end_origin) {
									isActive = true;
								}
							}
						} else if(this.date_select.length !== 0) {
							isActive = this._isSettingActive();

							if (date_options_sort.join() !== date_options_origin_sort.join() || this.date_select !== this.date_select_origin) {
								isActive = true;
							}
						}
					}					
				}
			} else {
				if ((this.assigned_select === UNASSIGNED ? true : this.append_select.length !== 0) && this.status_select.length !== 0 && this.job_type_selected.length !== 0 && this.budget_select.length !== 0 && this.date_options.length !== 0) {
					if (this.date_options.length === 1 && this.date_options[0] === Date_Options_No) {
						isActive = true;
					} else {
						if (this.date_select === 'range') {
							if (this.date_start || this.date_end) {
								isActive = true;
							}
						} else if(this.date_select.length !== 0) {
							isActive = true;
						}
					}
				}
			}
			return isActive;
		},
		_isSettingActive() {
			let isActive = false;

			if (this.assigned_select !== this.assigned_select_origin && (this.assigned_select === ANYONE ? true : this.append_select.length !== 0)) {
				isActive = true;
			}
			if (this.assigned_select === this.assigned_select_origin && (this.assigned_select === ANYONE ? true : this.append_select.length !== 0)) {
				if (this.append_select.length !== this.append_select_origin.length) {
					isActive = true;
				} else {
					const str = this.append_select.map(a => { return a.id});
					str.sort((a, b) => { return a-b });

					const str_origin = this.append_select_origin.map(a => { return a.id});
					str_origin.sort((a, b) => { return a-b });

					if (str.join() !== str_origin.join()) {
						isActive = true;
					}
				}
			}

			const status_tmp = this.status_select.map(a => { return a.value});
			const status_origin_tmp = this.status_select_origin.map(a => { return a.value});
			if (!this._isEqual(status_tmp, status_origin_tmp)) {
				isActive = true;
			}

			const job_type_tmp = this.job_type_selected.map(a => { return a.id});
			const job_type_origin_tmp = this.job_type_selected_origin.map(a => { return a.id});
			if (!this._isEqual(job_type_tmp, job_type_origin_tmp)) {
				isActive = true;
			}

			const budget_select_tmp = this.budget_select.map(a => { return a.value});
			const budget_select_origin_tmp = this.budget_select_origin.map(a => { return a.value});
			if (!this._isEqual(budget_select_tmp, budget_select_origin_tmp)) {
				isActive = true;
			}

			if (this.isPriority !== this.isPriority_origine) {
				isActive = true;
			}

			const priority_tmp = JSON.parse(JSON.stringify(this.priority_range));
			const priority_origin_tmp = JSON.parse(JSON.stringify(this.priority_rang_origine));
			if (!this._isEqual(priority_tmp, priority_origin_tmp)) {
				isActive = true;
			}	
			
			return isActive;
		}
	}
}
</script>
<style lang="scss" scoped>
.task-search {
  background: #FAFAFA;
  border: 1px solid #C9C9C9;
  border-radius: 4px;

}
.search-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #192A3E;
}
.search-text-disable {
	color: rgba(0, 0, 0, 0.38);
}
.panel-header-item {
  display: flex;
  flex-flow: column nowrap;
}
::v-deep {
  .theme--light.v-divider {
    border-color: rgba(25, 42, 62, 0.3);
  }
	.v-badge__badge {
		min-width: 14px;
		height: 14px;
	}
}
</style>